import request from '@/utils/request'

export const getControlPointList = ({ page, size, ...params }) => {
  return request({
    url: `/trace/controlpoint/${page}/${size}`,
    params
  })
}

// 启用/停用：status 1启用 0停用
export const postControlPointStatus = (id, status) => {
  return request({
    method: 'post',
    url: `/trace/controlpoint/status/${id}/${status}`
  })
}

export const postControlPointEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/controlpoint',
    data
  })
}

export const putControlPointAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/controlpoint',
    data
  })
}

export const getControlPointDetail = (id) => {
  return request({
    url: `/trace/controlpoint/${id}`
  })
}

export const deleteControlPointDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/controlpoint/${id}`
  })
}

export const delControlPointList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/controlpoint/all',
    data
  })
}
